<template>
    <router-link v-if="link" class="c-a-button" :class="modifiers" :to="link">
        <icon v-if="icon" :icon="icon"></icon>
        {{label}}
    </router-link>
</template>

<script>
    import Icon from './AtomIcon.vue';

    export default {
        props: {
            modifiers: String,
            label: String,
            icon: String,
            link: String|Object,
            disabled: Boolean
        },
        components: {
            Icon
        },
        computed: {
            classes: function() {
                let classes = '';
                classes += `${this.modifiers} `;
                classes += this.icon ? 'c-a-button--with-icon ' : '';
                classes += this.disabled ? 'c-a-button--disabled ' : ''
                return classes
            }
        },
    }
</script>



// WEBPACK FOOTER //
// src/views/components/atoms/AtomButtonLink.vue